module.exports = __webpack_public_path__ + "static/media/javascript.53e07caf.svg";